
<div  [ngClass]="{'content-absolute': pageHelpDrawer.isOpen}">
    <div [ngClass]="{'content-relative': pageHelpDrawer.isOpen}">
        <div id="page-help-drawer-container"  [ngClass]="{
            'page-help-display': !pageHelpDrawer.isOpen, 
            'page-help-zindex': pageHelpDrawer.isOpen,
        }">
            <div class="page-help-blur" (click)="onClickClose()"></div>
            <aside c11n-drawer [isModal]="false" [isSticky]="false" (drawerState)="drawerStateHandler($event)" #pageHelpDrawer>
                <div class="flex-column main">
                    <ng-container *ngFor="let content of pageHelp">
                        <page-help-parser [item]="content"></page-help-parser>
                    </ng-container>
                </div>
            </aside>
        </div>
    </div>
</div>